export const UPDATE_AVG_PRICE_WIDGET = "UPDATE_AVG_PRICE_WIDGET";